<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "ChatHistory",
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }],
      permission: {
        add: 'chatHistory:add',
        update: 'chatHistory:update',
        delete: 'chatHistory:delete',
        deleteBatch: 'chatHistory:deleteBatch'
      },
      url: {
        get: '/chatHistory/listByCondition',
        add: '/chatHistory/add',
        update: '/chatHistory/update',
        delete: '/chatHistory/delete/',
        delete_batch: '/chatHistory/deleteBatch',
        status: '/chatHistory/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        width: '',
      },{
        field: 'phone',
        label: '用户',
        show: true,
        width: '',
      },{
        field: 'moder',
        label: '模型名称',
        show: true,
        width: '',
      }, {
        field: 'sessionId',
        label: '对话ID',
        show: true,
        width: '',
      },{
        field: 'question',
        label: '提问',
        show: true,
        width: '',
      }, {
        field: 'createTime',
        label: '时间',
        show: true,
        width: '',
      }],
      operate: [],
      formFields: {
        addTitle: '对话Ai',
        updateTitle: '对话Ai',
        model: [{
          field: 'question',
          label: '提问',
          type: 'input',
          placeholder: '标题',
          rules: [{message: '请输入提问', trigger: 'blur', required: false}],
          add: true,
          update: true,
        }, {
          field: 'answer',
          label: '回答',
          type: 'editor',
          placeholder: '内容',
          rules: [{message: '请输入回答', trigger: 'blur', required: true}],
          add: true,
          update: true,
        },  {
          field: 'agentId',
          label: '代理：',
          type: 'select',
          placeholder: '请选择代理',
          rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
          selectUrl: '/agent/getAll',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        },{
          field: 'sessionId',
          label: '对话ID',
          type: 'input',
          placeholder: '对话ID',
          rules: [{message: '请输入对话ID', trigger: 'blur', required: false}],
          add: true,
          update: true,
        }],
      }
    }
  }
}
</script>

<style scoped>

</style>
